import * as React from 'react';

class CheckboxAgGridEditor extends React.Component{
  state = {
    checked: false,
  };

  componentDidMount() {
    this.setState({checked: this.props.value})
  }

  getValue = () => {
    return this.state.checked;
  };

  onChange = (e) => {
    const {column, agGridReact, node} = this.props;
    if (column.colDef.scenarioShow) {
      const data = node.data;
      data[column.colId] = e.target.value === 'true';
      agGridReact.props.scenarioFinStrDataChange(data);
    }
    this.setState({checked: e.target.value === 'true'})
  };

  render(){
    return(
      <select value={this.state.checked} onChange={e => this.onChange(e)}>
        <option value="true">true</option>
        <option value="false">false</option>
      </select>
    )
  }
}
export default CheckboxAgGridEditor;


// WEBPACK FOOTER //
// ./src/views/FinancicalStructure/FinancicalStructure/FieldRenderer/CheckboxAgGridEditor.js